import HTTP from "./http";
import Vue from "vue";

export default {
  async authenticate(creds) {
    try {
      creds.email = creds.email.toLowerCase();
      return await HTTP.withAccept.post("/authentication", creds);
    } catch (e) {
      throw e;
    }
  },
  async authenticateOldAPI(creds) {
    try {
      let res = await Vue.http.post(
        "https://api.donamaid.com/api/authenticate",
        creds,
        {
          emulateJSON: true
        }
      );

      if (!res.body.success) throw "Usuário ou senha incorretos!";

      return res.body.data;
    } catch (e) {
      throw e;
    }
  },
  async checkToken() {
    try {
      return await HTTP.withAccept.get("/token-check");
    } catch (e) {
      throw "Token inválido!";
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/authentication.js